<template>
  <component :is="tag"
             @click.native="hideSidebar"
             class="nav-item"
             v-bind="$attrs"
             tag="li">
    <a class="nav-link" :class="{'nav-image-link': !icon}">
      <slot>
        <template v-if="icon">
          <i v-if="icon" :class="icon"></i>
        </template>
        <template v-else>
          <img class="image active" :src="imageActive || image" />
          <img class="image" :src="image" />
        </template>
        <p>{{name}}</p>
      </slot>
    </a>
  </component>
</template>
<script>
export default {
  name: "sidebar-link",
  inheritAttrs: false,
  inject: {
    autoClose: {
      default: true
    },
    addLink: {
      default: ()=>{}
    },
    removeLink: {
      default: ()=>{}
    }
  },
  props: {
    name: String,
    icon: String,
    image: String,
    imageActive: String,
    tag: {
      type: String,
      default: "router-link"
    }
  },
  methods: {
    hideSidebar() {
      if (this.autoClose) {
        this.$sidebar.displaySidebar(false);
      }
    },
    isActive() {
      return this.$el.classList.contains("active");
    }
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
};
</script>
<style lang="scss">
.sidebar-wrapper {
  .nav {
    .nav-item {
      .nav-link {
        &.nav-image-link {
          .image {
            float: left;
            width: 30px;
            height: 30px;
            object-fit: scale-down;
            display: block;
            margin-right: 15px;
            &.active {
              display: none;
            }
          }
        }
      }
      &.active {
        .nav-link.nav-image-link {
          .image {
            display: none;
            &.active {
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>
